/**
 * Construction Workflow — GHL Pipeline Stage Mapping
 *
 * Two GHL pipelines under JD Rivero Construction sub-account:
 *   Ventas        (p2ZEjMort6BjUO1g2RJN) — 22 stages (1.1 – 5.)
 *   Construcción  (hx4Ipc59bCXOrnpfMyhZ) — 21 stages (5.1 – 10.1)
 *
 * Stage IDs → CON_PM_FLOW indices → CON_CLIENT_FLOW indices
 */

// ── Pipeline IDs ──────────────────────────────────────────────────────────────
export const VENTAS_PIPELINE_ID        = 'p2ZEjMort6BjUO1g2RJN'
export const CONSTRUCCION_PIPELINE_ID  = 'hx4Ipc59bCXOrnpfMyhZ'

// ── Phase palette (5 phases) ──────────────────────────────────────────────────
export const CON_PHASES = [
    { id: 'ventas',       key: 'admin.workflow.con_phase_ventas',       icon: 'FaBullhorn',       grad: 'from-rose-500 to-pink-500',       line: 'border-rose-300',   badge: 'bg-rose-500',   light: 'bg-rose-50 border-rose-200',    ring: 'ring-rose-300',   card: 'bg-rose-50 border-rose-300' },
    { id: 'presupuesto',  key: 'admin.workflow.con_phase_presupuesto',  icon: 'FaFileInvoiceDollar', grad: 'from-orange-500 to-amber-500', line: 'border-orange-300', badge: 'bg-orange-500', light: 'bg-orange-50 border-orange-200', ring: 'ring-orange-300', card: 'bg-orange-50 border-orange-300' },
    { id: 'legal',        key: 'admin.workflow.con_phase_legal',        icon: 'FaHandshake',      grad: 'from-indigo-500 to-blue-500',     line: 'border-indigo-300', badge: 'bg-indigo-500', light: 'bg-indigo-50 border-indigo-200', ring: 'ring-indigo-300', card: 'bg-indigo-50 border-indigo-300' },
    { id: 'diseno',       key: 'admin.workflow.con_phase_diseno',       icon: 'FaDraftingCompass', grad: 'from-amber-500 to-yellow-500',   line: 'border-amber-300',  badge: 'bg-amber-500',  light: 'bg-amber-50 border-amber-200',   ring: 'ring-amber-300',  card: 'bg-amber-50 border-amber-300' },
    { id: 'construccion', key: 'admin.workflow.con_phase_construccion', icon: 'FaHardHat',        grad: 'from-emerald-500 to-teal-500',   line: 'border-emerald-300',badge: 'bg-emerald-500',light: 'bg-emerald-50 border-emerald-200',ring: 'ring-emerald-300',card: 'bg-emerald-50 border-emerald-300' },
]

// ── GHL Stage UUID → CON_PM_FLOW index ───────────────────────────────────────
// Ventas pipeline (indices 0-21), Construcción pipeline (indices 22-42)
export const STAGE_TO_PM_STEP = {
    // Ventas — Phase 0: Ventas/Lead (1.1-1.7)
    'c4090225-5af6-41b9-89f4-fb4c56fde029':  0,  // 1.1. LEAD NUEVO (V)
    'aa987755-969e-4217-a6fa-e810757bafde':  1,  // 1.2. LLAMADA REPROGRAMADA (V)
    '87677e16-4410-4841-9304-c7b82fee7b2e':  2,  // 1.3. NO CONTESTO (V)
    '73110fe5-730e-467d-b568-36748faf67ba':  3,  // 1.4. LEAD FRIO (V)
    '9b09aa25-3a09-4cec-966a-cc49e52f1641':  4,  // 1.5. NO CALIFICADO / NO APLICA (V)
    'd6fdfa28-fbc4-471e-a17b-eecd5c366ce6':  5,  // 1.6. SOLO BUSCA INFORMACION (V)
    'f290de1e-b983-4142-9cd9-39bcb49ef125':  6,  // 1.7. VISITA PROGRAMADA (V)
    // Ventas — Phase 1: Presupuesto (2.0-2.5)
    'fbc6aad8-7257-44c0-82ec-e219483ea67a':  7,  // 2.0. SOLICITUD DE ESTIMADO
    'b3771052-8bf0-403f-9cb2-c76bcee0dd2d':  8,  // 2.1. ESTIMADO PREVIO (P)
    '07314194-f8bf-42b4-aded-e9243e63c1ae':  9,  // 2.2. POR PRESUPUESTO (P)
    '67c442fb-d295-4ad0-a2cc-fd09a83285a9': 10,  // 2.3. PRESUPUESTO POR MODIFICAR (P)
    '0db1cce9-a4f7-4eb9-b26c-79b57c3a6176': 11,  // 2.4. PRESUPUESTO ENTREGADO (P)
    '904944e9-8634-438d-93aa-b50f336d6914': 12,  // 2.5. PRESUPUESTO APROBADO (P)
    // Ventas — Phase 2: Legal & Finanzas (3.1-4.3)
    'cea72c16-9d7f-426e-bc7d-0b49b046b8f4': 13,  // 3.1. EN APLICACION DE CREDITO (A&F)
    '08574443-6549-4a30-82ef-299aa5ba3fbc': 14,  // 3.2. CREDITO APROBADO (A&F)
    'ac9b628a-4ffd-4788-8d6b-49e555b8aceb': 15,  // 3.3. CREDITO NEGADO (A&F) — EXIT
    'cefe8351-4f07-4726-a3ff-e1175a3ef865': 17,  // 3.4. PROYECTO EN HOLD (A&F) → CHOLD
    '69eb11f7-cb00-406c-9a13-f709e1d6a21b': 15,  // 3.5. PROYECTO CANCELADO (A&F) — EXIT → CEXIT
    'bce95e0e-f7cc-4f71-a382-f1adcffce017': 18,  // 4.1. GENERACION DE CONTRATO (L)
    'bfb10c67-c22d-46d5-81b9-978a60cc03fb': 19,  // 4.2. CONTRATO POR FIRMAR (L)
    'a4044e1d-2074-4cf8-81eb-fdf244f6f0fc': 20,  // 4.3. CONTRATO FIRMADO (L)
    '0b0fd2a9-eea3-42c1-8a74-fc2be217a001': 21,  // 5. PROYECTO → transition
    // Construcción — Phase 3: Diseño & Planos (5.1-6.3)
    '633d79e7-3f20-490b-8c38-a394ddbfe138': 22,  // 5.1. PROYECTO NUEVO
    '54749595-7362-47f9-ba42-34fdf01a42b3': 23,  // 5.2. CREACION SKETCH
    '31767001-4080-4681-9680-4a2968dec3ba': 24,  // 5.3. SKETCH ENVIADO AL CLIENTE
    '1822a252-0d7e-4749-9215-9374c8cb29c1': 25,  // 5.4. SKETCH APROBADO POR EL CLIENTE
    '739dbbc4-1fc0-464f-9342-7b1034575394': 26,  // 6.1. EN PROYECTO
    '45ff33ac-a7cc-4ada-aa75-f48dae136718': 27,  // 6.2. PROYECTO RECIBIDO – EN REVISION
    '4e95854e-4712-49e8-9220-0deede73ce4c': 28,  // 6.3. PROYECTO APROBADO
    // Construcción — Phase 3 cont: Permisos (7.1-7.7)
    '2a7fff98-df75-42a1-97c3-5086eaf31ca7': 29,  // 7.1. PREPARACION PERMISOLOGIA
    'aa9a8d3a-4e22-4591-bb68-2e091bf6ce42': 30,  // 7.2. REVISIONES DE LA CIUDAD
    '357abb52-b6ac-4706-8f46-686fd617aa44': 31,  // 7.3. PERMISO SOMETIDO A LA CIUDAD
    'cef79dbd-8a87-4650-bdec-c162cda84306': 32,  // 7.4. PERMISO APROBADO
    '1a743b72-8549-4f38-8278-97692ca1e9e8': 33,  // 7.5. CARTA INGRESO A LA PROPIEDAD
    '9418a330-048f-4370-92a3-8b1d1b4bf28c': 34,  // 7.6. COI
    '949034d6-1b49-474e-bb0e-1dbbe5cc528a': 35,  // 7.7. 811
    // Construcción — Phase 4: Compras (8.1-8.2)
    'a60d4052-add1-4867-ae77-29962de4ef2e': 36,  // 8.1. COMPRA MATERIALES
    'c8433a20-2107-46a4-9394-3296bb474ce2': 37,  // 8.2. MATERIALES EN OBRA
    // Construcción — Phase 4 cont: Construcción física (9.1-9.4)
    '69121d6b-4dea-4b32-b188-7f082cbe4337': 38,  // 9.1. EN CONSTRUCCION
    '9b95d497-19c6-4b25-8dda-c6bf6ae36734': 39,  // 9.2. POR INSPECCION
    'fcabdda6-41c8-4597-a1dc-41ae17a505ca': 40,  // 9.3. OBRA CULMINADA
    'a8d53b74-24dd-45ae-854c-b439a43d8e3c': 41,  // 9.4. INSPECCION FINAL APROBADA
    // Construcción — Phase 4 cont: Cierre (10.1)
    '61984d1a-be96-4b31-b46f-1d9f295c6bfa': 42,  // 10.1. CARTA CONFORMIDAD CLIENTE
}

// ── GHL Stage UUID → CON_CLIENT_FLOW index ───────────────────────────────────
// 9 simplified client steps
export const STAGE_TO_CLIENT_STEP = {
    // Pre-contract: client not onboarded yet
    'c4090225-5af6-41b9-89f4-fb4c56fde029': 0,
    'aa987755-969e-4217-a6fa-e810757bafde': 0,
    '87677e16-4410-4841-9304-c7b82fee7b2e': 0,
    '73110fe5-730e-467d-b568-36748faf67ba': 0,
    '9b09aa25-3a09-4cec-966a-cc49e52f1641': 0,
    'd6fdfa28-fbc4-471e-a17b-eecd5c366ce6': 0,
    'f290de1e-b983-4142-9cd9-39bcb49ef125': 0,
    // Presupuesto → c0: Presupuesto Aprobado
    'fbc6aad8-7257-44c0-82ec-e219483ea67a': 0,
    'b3771052-8bf0-403f-9cb2-c76bcee0dd2d': 0,
    '07314194-f8bf-42b4-aded-e9243e63c1ae': 0,
    '67c442fb-d295-4ad0-a2cc-fd09a83285a9': 0,
    '0db1cce9-a4f7-4eb9-b26c-79b57c3a6176': 0,
    '904944e9-8634-438d-93aa-b50f336d6914': 0,  // Presupuesto aprobado
    // Legal/Finanzas → c0 still
    'cea72c16-9d7f-426e-bc7d-0b49b046b8f4': 0,
    '08574443-6549-4a30-82ef-299aa5ba3fbc': 0,
    'ac9b628a-4ffd-4788-8d6b-49e555b8aceb': -1, // Crédito negado → EXIT
    'cefe8351-4f07-4726-a3ff-e1175a3ef865': -1, // En hold → suspended
    '69eb11f7-cb00-406c-9a13-f709e1d6a21b': -1, // Cancelado → EXIT
    // Contrato → c1
    'bce95e0e-f7cc-4f71-a382-f1adcffce017': 1,
    'bfb10c67-c22d-46d5-81b9-978a60cc03fb': 1,
    'a4044e1d-2074-4cf8-81eb-fdf244f6f0fc': 1,  // Contrato firmado
    '0b0fd2a9-eea3-42c1-8a74-fc2be217a001': 1,
    // Sketch/Diseño → c2
    '633d79e7-3f20-490b-8c38-a394ddbfe138': 2,
    '54749595-7362-47f9-ba42-34fdf01a42b3': 2,
    '31767001-4080-4681-9680-4a2968dec3ba': 2,
    '1822a252-0d7e-4749-9215-9374c8cb29c1': 2,
    // Planos → c3
    '739dbbc4-1fc0-464f-9342-7b1034575394': 3,
    '45ff33ac-a7cc-4ada-aa75-f48dae136718': 3,
    '4e95854e-4712-49e8-9220-0deede73ce4c': 3,
    // Permisos → c4
    '2a7fff98-df75-42a1-97c3-5086eaf31ca7': 4,
    'aa9a8d3a-4e22-4591-bb68-2e091bf6ce42': 4,
    '357abb52-b6ac-4706-8f46-686fd617aa44': 4,
    'cef79dbd-8a87-4650-bdec-c162cda84306': 4,
    '1a743b72-8549-4f38-8278-97692ca1e9e8': 4,
    '9418a330-048f-4370-92a3-8b1d1b4bf28c': 4,
    '949034d6-1b49-474e-bb0e-1dbbe5cc528a': 4,
    // Compras → c5
    'a60d4052-add1-4867-ae77-29962de4ef2e': 5,
    'c8433a20-2107-46a4-9394-3296bb474ce2': 5,
    // En construcción → c6
    '69121d6b-4dea-4b32-b188-7f082cbe4337': 6,
    // Inspección → c7
    '9b95d497-19c6-4b25-8dda-c6bf6ae36734': 7,
    'fcabdda6-41c8-4597-a1dc-41ae17a505ca': 7,
    'a8d53b74-24dd-45ae-854c-b439a43d8e3c': 7,
    // Entrega → c8
    '61984d1a-be96-4b31-b46f-1d9f295c6bfa': 8,
}

// ── CON_PM_FLOW (43 cards, flat serpentine) ───────────────────────────────────
// phase: 0=Ventas 1=Presupuesto 2=Legal&Finanzas 3=Diseño&Permisos 4=Construcción
export const CON_PM_FLOW = [
    // Phase 0 — Ventas / Lead (7)
    { id: 'CV1',  label: 'admin.workflow.con_cv1',  phase: 0, actor: 'system' },
    { id: 'CV2',  label: 'admin.workflow.con_cv2',  phase: 0, actor: 'pm',
      detail: [{ t: 'admin.workflow.con_cv2_d1' }] },
    { id: 'CV3',  label: 'admin.workflow.con_cv3',  phase: 0, actor: 'pm',
      detail: [{ t: 'admin.workflow.con_cv3_d1' }] },
    { id: 'CV4',  label: 'admin.workflow.con_cv4',  phase: 0, actor: 'pm',
      detail: [{ t: 'admin.workflow.con_cv4_d1' }] },
    { id: 'CV5',  label: 'admin.workflow.con_cv5',  phase: 0, actor: 'system',
      detail: [{ t: 'admin.workflow.con_cv5_d1', c: 'text-red-600' }] },
    { id: 'CV6',  label: 'admin.workflow.con_cv6',  phase: 0, actor: 'pm',
      detail: [{ t: 'admin.workflow.con_cv6_d1' }] },
    { id: 'CV7',  label: 'admin.workflow.con_cv7',  phase: 0, actor: 'pm',
      detail: [{ t: 'admin.workflow.con_cv7_d1' }] },
    // Phase 1 — Presupuesto (6)
    { id: 'CP1',  label: 'admin.workflow.con_cp1',  phase: 1, actor: 'pm' },
    { id: 'CP2',  label: 'admin.workflow.con_cp2',  phase: 1, actor: 'pm',
      detail: [{ t: 'admin.workflow.con_cp2_d1' }] },
    { id: 'CP3',  label: 'admin.workflow.con_cp3',  phase: 1, actor: 'pm',
      detail: [{ t: 'admin.workflow.con_cp3_d1' }] },
    { id: 'CP4',  label: 'admin.workflow.con_cp4',  phase: 1, actor: 'pm', decision: true,
      routes: [{ to: 'CP3', color: 'amber', label: 'admin.workflow.con_route_modify' }],
      detail: [{ t: 'admin.workflow.con_cp4_d1', c: 'text-amber-600' }] },
    { id: 'CP5',  label: 'admin.workflow.con_cp5',  phase: 1, actor: 'pm',
      detail: [{ t: 'admin.workflow.con_cp5_d1' }] },
    { id: 'CP6',  label: 'admin.workflow.con_cp6',  phase: 1, actor: 'client', decision: true,
      routes: [{ to: 'CP3', color: 'amber', label: 'admin.workflow.con_route_modify' }],
      detail: [{ t: 'admin.workflow.con_cp6_d1', c: 'text-green-600' }, { t: 'admin.workflow.con_cp6_d2', c: 'text-amber-600' }] },
    // Phase 2 — Legal & Finanzas (9)
    { id: 'CF1',  label: 'admin.workflow.con_cf1',  phase: 2, actor: 'pm',
      detail: [{ t: 'admin.workflow.con_cf1_d1' }] },
    { id: 'CF2',  label: 'admin.workflow.con_cf2',  phase: 2, actor: 'pm', decision: true,
      routes: [{ to: 'CEXIT', color: 'red', label: 'admin.workflow.con_route_denied' }],
      detail: [{ t: 'admin.workflow.con_cf2_d1', c: 'text-green-600' }, { t: 'admin.workflow.con_cf2_d2', c: 'text-red-600' }] },
    { id: 'CEXIT', label: 'admin.workflow.con_cexit', phase: 2, actor: 'system',
      detail: [{ t: 'admin.workflow.con_cexit_d1', c: 'text-red-600' }] },
    { id: 'CF3',  label: 'admin.workflow.con_cf3',  phase: 2, actor: 'pm',
      detail: [{ t: 'admin.workflow.con_cf3_d1' }] },
    { id: 'CHOLD', label: 'admin.workflow.con_chold', phase: 2, actor: 'system',
      detail: [{ t: 'admin.workflow.con_chold_d1', c: 'text-amber-600' }] },
    { id: 'CF4',  label: 'admin.workflow.con_cf4',  phase: 2, actor: 'pm',
      detail: [{ t: 'admin.workflow.con_cf4_d1' }] },
    { id: 'CF5',  label: 'admin.workflow.con_cf5',  phase: 2, actor: 'pm',
      detail: [{ t: 'admin.workflow.con_cf5_d1' }] },
    { id: 'CF6',  label: 'admin.workflow.con_cf6',  phase: 2, actor: 'client',
      detail: [{ t: 'admin.workflow.con_cf6_d1', c: 'text-green-600' }] },
    { id: 'CTRANS', label: 'admin.workflow.con_ctrans', phase: 2, actor: 'system',
      detail: [{ t: 'admin.workflow.con_ctrans_d1' }] },
    // Phase 3 — Diseño, Proyecto & Permisos (14)
    { id: 'CD1',  label: 'admin.workflow.con_cd1',  phase: 3, actor: 'pm' },
    { id: 'CD2',  label: 'admin.workflow.con_cd2',  phase: 3, actor: 'pm',
      detail: [{ t: 'admin.workflow.con_cd2_d1' }] },
    { id: 'CD3',  label: 'admin.workflow.con_cd3',  phase: 3, actor: 'pm',
      detail: [{ t: 'admin.workflow.con_cd3_d1' }] },
    { id: 'CD4',  label: 'admin.workflow.con_cd4',  phase: 3, actor: 'client', decision: true,
      routes: [{ to: 'CD2', color: 'amber', label: 'admin.workflow.con_route_modify' }],
      detail: [{ t: 'admin.workflow.con_cd4_d1', c: 'text-green-600' }, { t: 'admin.workflow.con_cd4_d2', c: 'text-amber-600' }] },
    { id: 'CD5',  label: 'admin.workflow.con_cd5',  phase: 3, actor: 'pm',
      detail: [{ t: 'admin.workflow.con_cd5_d1' }] },
    { id: 'CD6',  label: 'admin.workflow.con_cd6',  phase: 3, actor: 'pm', decision: true,
      routes: [{ to: 'CD5', color: 'red', label: 'admin.workflow.con_route_revision' }],
      detail: [{ t: 'admin.workflow.con_cd6_d1', c: 'text-green-600' }, { t: 'admin.workflow.con_cd6_d2', c: 'text-red-600' }] },
    { id: 'CD7',  label: 'admin.workflow.con_cd7',  phase: 3, actor: 'admin',
      detail: [{ t: 'admin.workflow.con_cd7_d1' }] },
    { id: 'CP7',  label: 'admin.workflow.con_cp7',  phase: 3, actor: 'admin',
      detail: [{ t: 'admin.workflow.con_cp7_d1' }] },
    { id: 'CP8',  label: 'admin.workflow.con_cp8',  phase: 3, actor: 'admin',
      detail: [{ t: 'admin.workflow.con_cp8_d1' }] },
    { id: 'CP9',  label: 'admin.workflow.con_cp9',  phase: 3, actor: 'admin',
      detail: [{ t: 'admin.workflow.con_cp9_d1' }] },
    { id: 'CP10', label: 'admin.workflow.con_cp10', phase: 3, actor: 'admin',
      detail: [{ t: 'admin.workflow.con_cp10_d1' }] },
    { id: 'CP11', label: 'admin.workflow.con_cp11', phase: 3, actor: 'admin',
      detail: [{ t: 'admin.workflow.con_cp11_d1' }] },
    { id: 'CP12', label: 'admin.workflow.con_cp12', phase: 3, actor: 'admin',
      detail: [{ t: 'admin.workflow.con_cp12_d1' }] },
    { id: 'CP13', label: 'admin.workflow.con_cp13', phase: 3, actor: 'admin',
      detail: [{ t: 'admin.workflow.con_cp13_d1' }] },
    // Phase 4 — Compras, Construcción & Cierre (9)
    { id: 'CC1',  label: 'admin.workflow.con_cc1',  phase: 4, actor: 'pm',
      detail: [{ t: 'admin.workflow.con_cc1_d1' }] },
    { id: 'CC2',  label: 'admin.workflow.con_cc2',  phase: 4, actor: 'pm',
      detail: [{ t: 'admin.workflow.con_cc2_d1' }] },
    { id: 'CC3',  label: 'admin.workflow.con_cc3',  phase: 4, actor: 'pm',
      detail: [{ t: 'admin.workflow.con_cc3_d1' }] },
    { id: 'CC4',  label: 'admin.workflow.con_cc4',  phase: 4, actor: 'pm', decision: true,
      routes: [{ to: 'CC3', color: 'amber', label: 'admin.workflow.con_route_inspection' }],
      detail: [{ t: 'admin.workflow.con_cc4_d1', c: 'text-green-600' }, { t: 'admin.workflow.con_cc4_d2', c: 'text-amber-600' }] },
    { id: 'CC5',  label: 'admin.workflow.con_cc5',  phase: 4, actor: 'pm',
      detail: [{ t: 'admin.workflow.con_cc5_d1' }] },
    { id: 'CC6',  label: 'admin.workflow.con_cc6',  phase: 4, actor: 'admin', decision: true,
      routes: [{ to: 'CC3', color: 'red', label: 'admin.workflow.con_route_failed' }],
      detail: [{ t: 'admin.workflow.con_cc6_d1', c: 'text-green-600' }, { t: 'admin.workflow.con_cc6_d2', c: 'text-red-600' }] },
    { id: 'CC7',  label: 'admin.workflow.con_cc7',  phase: 4, actor: 'pm',
      detail: [{ t: 'admin.workflow.con_cc7_d1' }] },
    { id: 'CC8',  label: 'admin.workflow.con_cc8',  phase: 4, actor: 'admin',
      detail: [{ t: 'admin.workflow.con_cc8_d1' }] },
    { id: 'CC9',  label: 'admin.workflow.con_cc9',  phase: 4, actor: 'client',
      detail: [{ t: 'admin.workflow.con_cc9_d1', c: 'text-green-600' }] },
]

// ── CON_CLIENT_FLOW (9 simplified cards) ──────────────────────────────────────
export const CON_CLIENT_FLOW = [
    { id: 'cl0', label: 'admin.workflow.con_cl0', phase: 1, actor: 'client', detail: [{ t: 'admin.workflow.con_cl0_d1' }] },
    { id: 'cl1', label: 'admin.workflow.con_cl1', phase: 2, actor: 'admin',  detail: [{ t: 'admin.workflow.con_cl1_d1' }] },
    { id: 'cl2', label: 'admin.workflow.con_cl2', phase: 3, actor: 'pm',     detail: [{ t: 'admin.workflow.con_cl2_d1' }] },
    { id: 'cl3', label: 'admin.workflow.con_cl3', phase: 3, actor: 'pm',     detail: [{ t: 'admin.workflow.con_cl3_d1' }] },
    { id: 'cl4', label: 'admin.workflow.con_cl4', phase: 3, actor: 'admin',  detail: [{ t: 'admin.workflow.con_cl4_d1' }] },
    { id: 'cl5', label: 'admin.workflow.con_cl5', phase: 4, actor: 'pm',     detail: [{ t: 'admin.workflow.con_cl5_d1' }] },
    { id: 'cl6', label: 'admin.workflow.con_cl6', phase: 4, actor: 'pm',     detail: [{ t: 'admin.workflow.con_cl6_d1' }] },
    { id: 'cl7', label: 'admin.workflow.con_cl7', phase: 4, actor: 'admin',  detail: [{ t: 'admin.workflow.con_cl7_d1' }] },
    { id: 'cl8', label: 'admin.workflow.con_cl8', phase: 4, actor: 'client', detail: [{ t: 'admin.workflow.con_cl8_d1' }] },
]

// ── Resolver: GHL stageId → flow step index ───────────────────────────────────
/**
 * Resolve active step for a Construction project.
 * @param {string|null} stageId — GHL pipelineStageId UUID
 * @param {boolean} isPm — true = PM view, false = client view
 * @returns {number} step index (0-based), -1 = suspended/exit/hold
 */
export function resolveConstructionStep(stageId, isPm) {
    if (!stageId) return 0
    const map = isPm ? STAGE_TO_PM_STEP : STAGE_TO_CLIENT_STEP
    const step = map[stageId]
    return step !== undefined ? step : 0
}

// ── Stage name lookup (for display) ──────────────────────────────────────────
export const STAGE_NAMES = {
    'c4090225-5af6-41b9-89f4-fb4c56fde029': '1.1. Lead Nuevo',
    'aa987755-969e-4217-a6fa-e810757bafde': '1.2. Llamada Reprogramada',
    '87677e16-4410-4841-9304-c7b82fee7b2e': '1.3. No Contestó',
    '73110fe5-730e-467d-b568-36748faf67ba': '1.4. Lead Frío',
    '9b09aa25-3a09-4cec-966a-cc49e52f1641': '1.5. No Calificado',
    'd6fdfa28-fbc4-471e-a17b-eecd5c366ce6': '1.6. Solo Busca Información',
    'f290de1e-b983-4142-9cd9-39bcb49ef125': '1.7. Visita Programada',
    'fbc6aad8-7257-44c0-82ec-e219483ea67a': '2.0. Solicitud de Estimado',
    'b3771052-8bf0-403f-9cb2-c76bcee0dd2d': '2.1. Estimado Previo',
    '07314194-f8bf-42b4-aded-e9243e63c1ae': '2.2. Por Presupuesto',
    '67c442fb-d295-4ad0-a2cc-fd09a83285a9': '2.3. Presupuesto por Modificar',
    '0db1cce9-a4f7-4eb9-b26c-79b57c3a6176': '2.4. Presupuesto Entregado',
    '904944e9-8634-438d-93aa-b50f336d6914': '2.5. Presupuesto Aprobado',
    'cea72c16-9d7f-426e-bc7d-0b49b046b8f4': '3.1. En Aplicación de Crédito',
    '08574443-6549-4a30-82ef-299aa5ba3fbc': '3.2. Crédito Aprobado',
    'ac9b628a-4ffd-4788-8d6b-49e555b8aceb': '3.3. Crédito Negado',
    'cefe8351-4f07-4726-a3ff-e1175a3ef865': '3.4. Proyecto en Hold',
    '69eb11f7-cb00-406c-9a13-f709e1d6a21b': '3.5. Proyecto Cancelado',
    'bce95e0e-f7cc-4f71-a382-f1adcffce017': '4.1. Generación de Contrato',
    'bfb10c67-c22d-46d5-81b9-978a60cc03fb': '4.2. Contrato por Firmar',
    'a4044e1d-2074-4cf8-81eb-fdf244f6f0fc': '4.3. Contrato Firmado',
    '0b0fd2a9-eea3-42c1-8a74-fc2be217a001': '5. Proyecto',
    '633d79e7-3f20-490b-8c38-a394ddbfe138': '5.1. Proyecto Nuevo',
    '54749595-7362-47f9-ba42-34fdf01a42b3': '5.2. Creación Sketch',
    '31767001-4080-4681-9680-4a2968dec3ba': '5.3. Sketch Enviado al Cliente',
    '1822a252-0d7e-4749-9215-9374c8cb29c1': '5.4. Sketch Aprobado',
    '739dbbc4-1fc0-464f-9342-7b1034575394': '6.1. En Proyecto',
    '45ff33ac-a7cc-4ada-aa75-f48dae136718': '6.2. Proyecto en Revisión',
    '4e95854e-4712-49e8-9220-0deede73ce4c': '6.3. Proyecto Aprobado',
    '2a7fff98-df75-42a1-97c3-5086eaf31ca7': '7.1. Preparación Permisolología',
    'aa9a8d3a-4e22-4591-bb68-2e091bf6ce42': '7.2. Revisiones de la Ciudad',
    '357abb52-b6ac-4706-8f46-686fd617aa44': '7.3. Permiso Sometido',
    'cef79dbd-8a87-4650-bdec-c162cda84306': '7.4. Permiso Aprobado',
    '1a743b72-8549-4f38-8278-97692ca1e9e8': '7.5. Carta Ingreso a la Propiedad',
    '9418a330-048f-4370-92a3-8b1d1b4bf28c': '7.6. COI',
    '949034d6-1b49-474e-bb0e-1dbbe5cc528a': '7.7. 811',
    'a60d4052-add1-4867-ae77-29962de4ef2e': '8.1. Compra Materiales',
    'c8433a20-2107-46a4-9394-3296bb474ce2': '8.2. Materiales en Obra',
    '69121d6b-4dea-4b32-b188-7f082cbe4337': '9.1. En Construcción',
    '9b95d497-19c6-4b25-8dda-c6bf6ae36734': '9.2. Por Inspección',
    'fcabdda6-41c8-4597-a1dc-41ae17a505ca': '9.3. Obra Culminada',
    'a8d53b74-24dd-45ae-854c-b439a43d8e3c': '9.4. Inspección Final Aprobada',
    '61984d1a-be96-4b31-b46f-1d9f295c6bfa': '10.1. Carta Conformidad Cliente',
}

// ── Phase color badge for project cards ───────────────────────────────────────
const PM_PHASE_RANGES = [
    { max:  6, phase: 0 }, // Ventas
    { max: 12, phase: 1 }, // Presupuesto
    { max: 21, phase: 2 }, // Legal & Finanzas
    { max: 35, phase: 3 }, // Diseño & Permisos
    { max: 42, phase: 4 }, // Construcción & Cierre
]

const PHASE_BADGE_COLORS = [
    'bg-rose-100 text-rose-700',
    'bg-orange-100 text-orange-700',
    'bg-indigo-100 text-indigo-700',
    'bg-amber-100 text-amber-700',
    'bg-emerald-100 text-emerald-700',
]

export function getPhaseIndex(stageId) {
    if (!stageId) return -1
    const step = STAGE_TO_PM_STEP[stageId]
    if (step === undefined) return -1
    for (const r of PM_PHASE_RANGES) {
        if (step <= r.max) return r.phase
    }
    return -1
}

export function getConstructionPhaseColor(stageId) {
    if (!stageId) return 'bg-gray-100 text-gray-500'
    const step = STAGE_TO_PM_STEP[stageId]
    if (step === undefined || step < 0) return 'bg-gray-200 text-gray-500'
    for (const r of PM_PHASE_RANGES) {
        if (step <= r.max) return PHASE_BADGE_COLORS[r.phase]
    }
    return 'bg-gray-100 text-gray-500'
}
